/**
 * modules
 */
import angular from 'angular';
import services from './services/register';

const moduleName = 'pms-api',
    module = angular.module(moduleName, []);

services(module);

export default moduleName;



// WEBPACK FOOTER //
// ./src/pms-api/pms-api.module.js